﻿import * as $ajax from './_ajax'
import * as $modal from './_modal'

export module tooltips {
    export function initializeTooltips(root: JQuery) {
        setTimeout(() => {
            const textNames = [] as string[]

            root.find('.bcfla-helptext').each((_, el) => {
                textNames.push($(el).attr('data-name'))
            })

            $ajax.post({
                loadingText: 'Laddar...',
                url: '/Help/GetTooltips',
                data: {
                    names: textNames.join(','),
                },
                success: function (
                    res: { name: string; tooltip: string; isnew: boolean; hascontent: boolean }[]
                ) {
                    root.find('.bcfla-helptext').each((_, el) => {
                        const elem: JQuery = $(el)
                        const name: string = elem.attr('data-name')
                        const text = res.find((r) => r.name === name)
                        const placement = elem.attr('data-placement') || 'top'

                        if (!text) {
                            console.warn('text not found', name)
                            elem.hide()
                            return
                        }

                        elem.attr('title', text.tooltip)
                        elem.tooltip({ delay: 300, html: true, placement })

                        if (text.isnew) elem.addClass('bcfla-helptext--new')

                        if (text.hascontent) {
                            elem.click(() => {
                                $modal.load('/help/helptextmodal', { name }, true, true, false)
                                elem.removeClass('bcfla-helptext--new')
                            })
                        } else {
                            elem.addClass('bcfla-helptext--nolink')
                            elem.hover(() => {
                                $ajax.post({
                                    url: '/help/helptextmarkasread',
                                    data: { name },
                                    dataType: 'html',
                                })
                                elem.removeClass('bcfla-helptext--new')
                            })
                        }
                    })
                },
            })
        }, 2000)
    }
}
